import { makeStyles, Theme } from "@material-ui/core/styles";
import { InspectionPhoto } from "../types/types";
import { Box, Button, Typography } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import { ConfirmationButton } from "@roc/ui";
import { Flag, FlagOutlined } from "@material-ui/icons";
import { useStore } from "@roc/client-portal-shared/hooks";

const useStyles = makeStyles((theme: Theme) => ({
  logoWrapper: {
    background: '#fff',
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "48px",
    height: "48px",
    borderRadius: "50%",
  },
  logo: { fontSize: 32, color: "#D32F2F" },
  reportButton: {
    backgroundColor: "#D32F2F",
    color: "#fff",
    '&:hover': {
      backgroundColor: "#b71c1c",
    },
  },
  unreportButton: {
    backgroundColor: "#e06d6d",
    color: "#fff",
    '&:hover': {
      backgroundColor: "#c54949",
    },
  },
  alertMessage: {
    marginTop: theme.spacing(2),
  },
  container: {
    marginTop: theme.spacing(2),
  }
}));

interface ReportPhotoProps {
  inspectionPhoto: InspectionPhoto;
}

export const ReportPhoto = ({ inspectionPhoto }: ReportPhotoProps) => {
  const classes = useStyles();
  const { inspectionStore } = useStore();
  const { inspectionPhotosStore } = inspectionStore;

  if (!inspectionPhoto.reported) {
    return (
      <Box className={classes.container}>
        <ConfirmationButton
          testId="report-photo"
          variant="contained"
          className={classes.reportButton}
          onClick={() => inspectionPhotosStore.setPhotoReported(inspectionPhoto.inspectionPhotoId, true)}
          confirmDialogProps={{
            title: "Report this photo",
            removeContentBox: true,
            dialogLogo: (
              <Box className={classes.logoWrapper}>
                <Flag className={classes.logo} />
              </Box>
            ),
            body: (
              <Box>
                <Typography paragraph>Is this an inappropriate photograph?</Typography>
                <Typography paragraph>By reporting this photo we will hide from all of the reports, and it will be blurred in the future.</Typography>
                <Typography paragraph>Do you want to continue?</Typography>
              </Box>
            ),
            confirmButtonText: "Continue",
          }}
          startIcon={<FlagOutlined />}
        >
          REPORT PHOTO
        </ConfirmationButton>
      </Box>
    );
  }
  return (
    <Box className={classes.container}>
      <Button
        variant="contained"
        className={classes.unreportButton}
        startIcon={<FlagOutlined />}
        onClick={() => inspectionPhotosStore.setPhotoReported(inspectionPhoto.inspectionPhotoId, false)}
      >
        UN-REPORT PHOTO
      </Button>

      <Alert severity="error" className={classes.alertMessage}>
        <AlertTitle>
          <strong>Reported Photo</strong>
        </AlertTitle>

        This photo has been flagged and reported due to it's content. Proceed with caution.
        You can <strong>un-report the photo</strong> if you consider it was a mistake.
      </Alert>
    </Box>
  );
}
